import { Component, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
  Componente para mostrar un modal de errores relacionado con destinos.
  Este componente permite mostrar un modal con opciones configurables,
  como código de error, impresión de tarjeta y un identificador único.
  Además, proporciona acciones para redirigir a otras páginas y cerrar el modal.
**/

@Component({
    selector: 'app-errors-modal-destination',
    templateUrl: './errors-modal-destination.component.html',
    styleUrls: ['./errors-modal-destination.component.scss'],
    standalone: false
})
export class ErrorsModalDestinationComponent implements OnInit {
 /**
    Código del error.
  **/
    @Input() public codeError: string = '';

    /**
      Indica si se debe imprimir una tarjeta.
    **/
    @Input() public printCard: string = '';
  
    /**
      Identificador único del error.
    **/
    @Input() public uuidError: string = '';

  constructor(
    private _router: Router,
    private modalService: NgbModal,
     ) { }

  ngOnInit(): void {
  }

  /**
    Redirige a la página de búsqueda de destinos y cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario hace clic en el botón de reserva.
    @return void - No retorna ningún valor.
  **/
  actionBtnReservation() {
    this._router.navigate(['/find-destination']);
    this.modalService.dismissAll()

  }
  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario hace clic en el botón de cerrar.
    @return void - No retorna ningún valor.
  **/
  close() {
    this.modalService.dismissAll()
  }
  /**
    Redirige a la página de escaneo de pasaporte y cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario hace clic en el botón de embarque.
    @return void - No retorna ningún valor.
  **/
  actionBtnBoarding() {
    this._router.navigate(['/scan-passport']);
    this.modalService.dismissAll()
  }


}
